import { Repeat } from 'lucide-react'

interface RepeatPulseRingProps {
  size?: number
  duration?: number // Animation duration in seconds
}

export function RepeatPulseRing({
  size = 64,
  duration = 1,
}: RepeatPulseRingProps) {
  const iconSize = size * 0.5 // Icon is 50% of total size

  return (
    <div
      className='relative flex items-center justify-center'
      style={{ width: size, height: size }}
    >
      <style jsx>{`
        .pulse-ring {
          position: absolute;
          left: 50%;
          top: 50%;
          opacity: 0;
          border: 2px solid var(--accent-primary);
          border-radius: 50%;
          animation: pulsate ease-out infinite;
          transform-origin: center;
        }

        @keyframes pulsate {
          0% {
            transform: translate(-50%, -50%) scale(0.1);
            opacity: 0.0;
          }
          50% {
            opacity: 1.0;
          }
          100% {
            transform: translate(-50%, -50%) scale(1.5);
            opacity: 0.0;
          }
        }
      `}</style>

      {/* Icon in center */}
      <Repeat className='text-accent-primary relative z-10' size={iconSize} />

      {/* Single pulsing ring */}
      <div
        className='pulse-ring'
        style={{
          width: size * 0.8,
          height: size * 0.8,
          animationDuration: `${duration}s`,
        }}
      />
    </div>
  )
}
